import type { AirportBusEstimationTimeStrategy } from "../config/types";

/**
 * Builds the time string sent with estimation.
 * Airport-bus tickets may be whole-day (no UI time picker); the API still requires a time.
 */
export function resolveAirportBusEstimationTime(
  strategy: AirportBusEstimationTimeStrategy,
  now: Date = new Date()
): string {
  if (strategy === "current-local-time") {
    return `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
  }

  // Exhaustiveness guard for future strategies.
  const _exhaustive: never = strategy;
  return _exhaustive;
}
